export const NULL_RECEIPT = 'nullReceipt';
export const MONTHLY_RECEIPT = 'monthlyReceipt';
export const YEARLY_RECEIPT = 'yearlyReceipt';
